import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class EditorService {
    private baseUrl = environment.backendApiUrl;
    // private baseUrl = 'http://localhost:8000';
    constructor(private http: HttpClient) {}

    async editorService(
        urlStrt: string,
        user: string,
        body: any
    ): Promise<any> {
        const url = `${this.baseUrl}/file-update?url=${urlStrt}&user=${user}`;

        try {
            const response = await firstValueFrom(this.http.post(url, body));
            return response;
        } catch (error: any) {
            const message = error?.error?.detail;
            throw new Error(message);
        }
    }

    async generateSRT(body: any): Promise<any> {
        const url = `${this.baseUrl}/convert/generate-srt`;

        try {
            const response = await firstValueFrom(
                this.http.post(url, body, { responseType: 'text' })
            );
            return response;
        } catch (error: any) {
            const message = error?.msg;
            throw new Error(message);
        }
    }

    async generateSTL(body: any): Promise<any> {
        const url = `${this.baseUrl}/convert/generate-stl`;

        try {
            const response = await firstValueFrom(
                this.http.post(url, body, { responseType: 'blob' })
            );
            return response;
        } catch (error: any) {
            const message = error?.msg;
            throw new Error(message);
        }
    }

    async generateVTT(body: any): Promise<any> {
        const url = `${this.baseUrl}/convert/generate-vtt`;

        try {
            const response = await firstValueFrom(
                this.http.post(url, body, { responseType: 'blob' })
            );
            return response;
        } catch (error: any) {
            const message = error?.msg;
            throw new Error(message);
        }
    }
}
